import { Box } from "@mui/material";
import {
	UploadContentTypeSelector,
	UploadContentType,
} from "components/UploadContentTypeSelector";
import * as labels from "./constants";
import { CardShell, ReadonlyField } from "./shared";

interface uploadContentTypeCardProps {
	readonly?: boolean;
	uploadContentTypeLabel?: string | null;
	uploadContentTypes?: UploadContentType[];
	uploadContentType?: UploadContentType | null;
	onUploadContentTypeChange?: (val: UploadContentType | null) => void;
	onTemplateDownload?: () => void;
	downloading?: boolean;
}

export function UploadContentTypeCard({
	readonly = false,
	uploadContentTypeLabel,
	uploadContentTypes,
	uploadContentType,
	onUploadContentTypeChange,
	onTemplateDownload,
	downloading = false,
}: uploadContentTypeCardProps): React.JSX.Element {
	if (readonly && !uploadContentTypeLabel) return <></>;

	return (
		<CardShell readonly={readonly} label={labels.UploadContentType} toolTip="Select the type of data you will upload">
			{readonly ? (
				<ReadonlyField label={labels.Type} value={uploadContentTypeLabel!} />
			) : (
				<Box data-test-selector="upload-content-type-dropdown">
					<UploadContentTypeSelector
						options={uploadContentTypes}
						value={uploadContentType}
						onChange={onUploadContentTypeChange}
						onDownload={onTemplateDownload}
						downloading={downloading}
					/>
				</Box>
			)}
		</CardShell>
	);
}
